import React from 'react'
import {Flex} from '/app/src/component'
import style from './style.css'
import {NavLink} from 'react-router-dom'
import SVG from 'react-inlinesvg';


class MainItem extends React.Component {
    render(){
        let text = this.props.text
        let icon = this.props.imgSrc ?
            <img className={style.ItemIcon} alt='' src={this.props.imgSrc}/>
            : <SVG cacheGetRequests={true} style={{fill: this.props.svgfill}} className={style.ItemIcon} src={this.props.svgSrc} />
        return (
            <Flex className={style.MenuItemWrapper} column shrink={0}>
            <NavLink to={this.props.to} exact={this.props.exact} activeClassName={style.MenuItemSelected} className={style.MenuItem}>
                <Flex height='100%'>
                    <Flex hAlignContent='center' vAlignContent='center' basis='30%'>
                        {icon}
                    </Flex>
                    <Flex grow hAlignContent='left' vAlignContent='center'>
                        {text}
                    </Flex>
                </Flex>
            </NavLink>
            </Flex>
        )
    }
}

export default MainItem;



// WEBPACK FOOTER //
// ./src/component/Menu/MainItem.js